import React from 'react';
import { Section } from './ui/Section';
import { FileText, CheckSquare, List, Sun } from 'lucide-react';
export function OfferSection() {
  return <div className="bg-midnight-900" data-id="element-46">
      <Section className="space-y-16" data-id="element-47">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-48">
          {/* What's Included */}
          <div data-id="element-49">
            <h3 className="text-2xl font-display font-bold text-white mb-8 border-b border-[rgba(255,255,255,0.08)] pb-4 tracking-wide" data-id="element-50">
              Qué incluye (Acceso Inmediato)
            </h3>
            <ul className="space-y-6" data-id="element-51">
              <li className="flex gap-4" data-id="element-52">
                <div className="bg-[rgba(255,255,255,0.03)] p-3 rounded-[12px] h-fit border border-[rgba(255,255,255,0.05)]" data-id="element-53">
                  <FileText className="w-6 h-6 text-accent-blue" data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <h4 className="font-bold text-white text-lg" data-id="element-56">
                    Manual Completo PDF
                  </h4>
                  <p className="text-slate-300 text-sm" data-id="element-57">
                    45–70 páginas en español con toda la teoría y práctica.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-58">
                <div className="bg-[rgba(255,255,255,0.03)] p-3 rounded-[12px] h-fit border border-accent-blue/30 shadow-[0_0_15px_rgba(45,125,255,0.1)]" data-id="element-59">
                  <CheckSquare className="w-6 h-6 text-accent-blue" data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <h4 className="font-bold text-accent-blue text-lg" data-id="element-62">
                    Tarjeta de Noche Imprimible
                  </h4>
                  <p className="text-slate-300 text-sm" data-id="element-63">
                    Tu herramienta de rescate para tener en la mesa de luz. Paso
                    a paso de 12 minutos.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-64">
                <div className="bg-[rgba(255,255,255,0.03)] p-3 rounded-[12px] h-fit border border-[rgba(255,255,255,0.05)]" data-id="element-65">
                  <List className="w-6 h-6 text-accent-blue" data-id="element-66" />
                </div>
                <div data-id="element-67">
                  <h4 className="font-bold text-white text-lg" data-id="element-68">
                    Checklist de 14 noches
                  </h4>
                  <p className="text-slate-300 text-sm" data-id="element-69">
                    Para seguir tu progreso y mantener la constancia sin
                    esfuerzo.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-70">
                <div className="bg-[rgba(255,255,255,0.03)] p-3 rounded-[12px] h-fit border border-[rgba(255,255,255,0.05)]" data-id="element-71">
                  <Sun className="w-6 h-6 text-accent-blue" data-id="element-72" />
                </div>
                <div data-id="element-73">
                  <h4 className="font-bold text-white text-lg" data-id="element-74">
                    Plan "Me levanto sin drama"
                  </h4>
                  <p className="text-slate-300 text-sm" data-id="element-75">
                    Estrategia específica para cuando el sueño no vuelve, para
                    no arruinar el día siguiente.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* What You'll Feel */}
          <div className="card-glass p-8" data-id="element-76">
            <h3 className="text-2xl font-display font-bold text-white mb-8 tracking-wide" data-id="element-77">
              Lo que vas a sentir
            </h3>
            <div className="space-y-6" data-id="element-78">
              {['No estoy improvisando a las 3AM.', 'Mi cuerpo se calma más rápido.', 'Una mala noche ya no me destruye la semana.', 'Vuelvo a confiar en mi cama.'].map((text, i) => <div key={i} className="flex items-center gap-4" data-id="element-79">
                  <div className="h-px w-8 bg-accent-blue/50" data-id="element-80" />
                  <p className="text-lg text-white italic" data-id="element-81">"{text}"</p>
                </div>)}
            </div>

            <div className="mt-12 pt-8 border-t border-[rgba(255,255,255,0.08)]" data-id="element-82">
              <p className="text-center text-slate-400/60 text-sm" data-id="element-83">
                Diseñado específicamente para mujeres 55+
              </p>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}